import { getOnCallIntegrationSchedules } from "api/onCallIntegrationSchedules";
import constate from "constate";
import { useOpenGlobalErrorModal } from "hooks/useGlobalError";
import { type Map } from "immutable";
import { type OnCallIntegrationScheduleModel } from "models/OnCallIntegrationScheduleModel";
import { useCallback, useRef, useState } from "react";

const useOnCallIntegrationSchedules = () => {
  const [onCallIntegrationSchedules, setOnCallIntegrationSchedules] = useState<Map<
    string,
    OnCallIntegrationScheduleModel
  > | null>(null);
  const openGlobalErrorModal = useOpenGlobalErrorModal();
  const loadingRef = useRef(false);

  const loadOnCallIntegrationSchedules = useCallback(async () => {
    if (loadingRef.current) return;
    try {
      loadingRef.current = true;
      const newSchedules = await getOnCallIntegrationSchedules();
      loadingRef.current = false;
      setOnCallIntegrationSchedules(newSchedules);
    } catch (error) {
      loadingRef.current = false;
      openGlobalErrorModal(error as Error);
    }
  }, [openGlobalErrorModal]);

  return { actions: { loadOnCallIntegrationSchedules }, state: { onCallIntegrationSchedules } };
};

export const [OnCallIntegrationSchedulesProvider, useOnCallIntegrationSchedulesContext] =
  constate(useOnCallIntegrationSchedules);
